import { render, staticRenderFns } from "./PriceElement.vue?vue&type=template&id=65019f46"
import script from "./PriceElement.vue?vue&type=script&lang=js"
export * from "./PriceElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports